import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../actions/userActions';
import '../css/user.css';

export class LoginComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {
                username: '',
                password: ''
            }
        };
        this.verifyUser = this.verifyUser.bind(this);
        this.inputHandler = this.inputHandler.bind(this);

    }

    componentDidMount() {
        this.props.authenticateUser();
    }

    verifyUser() {
        this.props.loginUser(this.state.user)
    }

    inputHandler(e) {
        let formFields = this.state.user;
        formFields[e.target.name] = e.target.value;
        this.setState({
            formFields
        });
    }

    componentDidUpdate() {
        if (this.props.isLoggedIn) {
            window.location.href = '/publish';
        }
    }

    render() {
        return (
            <div className="userWrapper">
                <h2>Sign In</h2>
                <div className="formContent">
                    <form>
                        <input type="text" name="username" value={this.state.user.username} onChange={this.inputHandler} placeholder="Enter Username" />
                        <input type="password" name="password" value={this.state.user.password} onChange={this.inputHandler} placeholder="Enter Password" />
                        <button type="button" onClick={this.verifyUser}>Sign In</button>
                    </form>
                    {this.props.errorMessage && <p className="error">{this.props.errorMessage}</p>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { isLoggedIn, errorMessage } = state.user;

    return {
        isLoggedIn,
        errorMessage,
    };
}

const actionCreators = { loginUser: userActions.loginUser, authenticateUser: userActions.authenticateUser }

export default connect(mapStateToProps, actionCreators)(LoginComponent);